import { RichTextEditor as MantineRichTextEditor, RichTextEditorControlsGroupProps } from "@mantine/tiptap";
import clsx from "clsx";
import { FunctionComponent } from "react";
import styles from "../rich-text-editor.module.scss";

/**
 * Controls group wrapper. Mantine applies `background-color: var(--mantine-color-body)` to the group, which fights the
 * surrounding toolbar / paper. We pass our class via `className` directly so the transparent background sticks (the
 * parent's compound `classNames.controlsGroup` did not reach the rendered element).
 */
export const ControlsGroup: FunctionComponent<RichTextEditorControlsGroupProps> = ({ className, ...other }) => (
    <MantineRichTextEditor.ControlsGroup className={clsx(styles["controls-group"], className)} {...other} />
);

ControlsGroup.displayName = "RichTextEditor.ControlsGroup";
